import { api } from 'services/companiesApi';

interface ChangeDateCampaign {
	time?: string;
	date?: string;
	campaignId: string;
	communicationId?: string;
}

export const changeDateCampaign = ({
	campaignId,
	time,
	date,
	communicationId,
}: ChangeDateCampaign) => {
	return api.put(`/campaigns/${campaignId}/communications/${communicationId}`, {
		campaignCommunicationId: communicationId,
		campaignId: campaignId,
		sendingDate: date,
		sendingTime: time,
	});
};
